import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { TextField, Box } from "@mui/material"; // Import Box
import dayjs from "dayjs";

const injectShakeStyles = () => {
  if (document.getElementById("shake-style")) return;

  const style = document.createElement("style");
  style.id = "shake-style";
  style.innerHTML = `
    @keyframes shake {
      0%, 100% { left: 0; }
      20%, 60% { left: -6px; }
      40%, 80% { left: 6px; }
    }

    .shake-effect {
      position: relative;
      animation: shake 0.3s ease;
      border: 2px solid red !important;
      border-radius: 8px;
      z-index: 1500; /* ensures it stays on top */
    }
  `;
  document.head.appendChild(style);
};

const FormInputDateTime = ({
  name,
  control,
  label,
  placeholder,
  errors,
  mandatory = false,
  defaultValue = null,
  sx = {},

  fullWidth,
}) => {
  useEffect(() => {
    injectShakeStyles();
  }, []);

  const triggerShakeOnPopup = () => {
    const popup = document.querySelector(".MuiPickersPopper-root");
    if (popup) {
      popup.classList.add("shake-effect");
      setTimeout(() => {
        popup.classList.remove("shake-effect");
      }, 400);
    }
  };

  const handleChange = (value) => {
    if (!value) return;

    const now = dayjs();
    const selected = dayjs(value);

    if (selected.isBefore(now, "day")) {
      triggerShakeOnPopup();
    }
  };

  return (
    <Box sx={{ width: "100%", mb: 3, ...sx }}>
      {" "}
      {/* Apply marginTop here */}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{ required: mandatory }}
        render={({ field }) => (
          <DateTimePicker
            {...field}
            label={label}
            value={field.value ? dayjs(field.value) : null}
            inputFormat="MMM DD, YYYY hh:mm A"
            onChange={(value) => {
              handleChange(value);
              field.onChange(value);
            }}
            PopperProps={{
              modifiers: [
                { name: "preventOverflow", enabled: false },
                {
                  name: "computeStyles",
                  options: { gpuAcceleration: false },
                },
                {
                  name: "eventListeners",
                  options: { scroll: false, resize: false },
                },
              ],
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                 sx={{ width: "100%" }}
                error={!!errors[name]}
                helperText={errors[name]?.message || ""}
              />
            )}
          />
        )}
      />
    </Box>
  );
};

export { FormInputDateTime };
